export default __webpack_public_path__ + "static/media/1.c9bd83f2.png";